<template>
  <div id="home" class="pb-5">

    <div class="d-flex justify-content-center searchBg">
      <div class="align-self-center">
        <div class="mb-4 decoTxt">Start Your Journey Today!</div>
        <search-box :selectedCategory="selectedCategory" :options="options"></search-box>
      </div>
    </div>

    <!--  -->
    <b-container class="mt-5 alertbg">
      <b-row class="pb-3">
        <b-col cols="12" class="p-0 mb-1">
          <h3 class="text_orange">提醒您</h3>
        </b-col>
        <b-col cols="12" class="p-0 mb-1">
          <ul>
            <li>在查閱行程時，請細心閱讀相關內容，以確保全面了解所有細節。</li><br />

            <li>某些行程，特別是針對國外高爾夫團或特殊團體的旅遊行程，機票及機票稅金等費用<span class="text-danger">不包括</span>在行程中。</li>
            <li>旅客可選擇自行安排，或委託我們代訂，費用依提供護照當天報價為準。</li><br />
            <li>
              高爾夫團、特殊團及MINITOUR等團體行程，通常會安排當地的華語導遊陪同，為旅客提供專業與親切的服務。<br />
              若客人有特殊需求希望安排領隊，則可提供此服務，但需額外支付相應費用。具體費用將根據當時報價提供。<br />
              敬請理解並見諒，感謝您的支持與配合。
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>

    <!-- 等待載入時的畫面 -->
    <b-container class="py-4" v-if="recommended.length === 0">
      <div class="block_bg">
        <div class="skeleton">
          <b-skeleton height="40px" width="170px" class="mb-3"></b-skeleton>
        </div>
        <b-skeleton-img no-aspect height="281px"></b-skeleton-img>
      </div>
    </b-container>

    <!-- OUR RECOMMENDED 精選 -->
    <section class="pt-2" v-if="recommended.length > 0">
      <b-container class="mt-5 recommended">
        <b-row class="pb-3">
          <b-col cols="12" class="text-center p-0 mb-1">
            <h3 class="text_orange">{{ $t('index.recommended') }}</h3>
          </b-col>
          <!-- 旅遊團卡片 -->
          <b-col cols="6" sm="4" class="mb-2" v-for="tour in recommended" :key="tour.id">
            <ProductCard :tour="tour" :tours="tour" />
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- AD宣傳版面 小尺寸時不顯示 -->
    <b-container class="d-none d-md-block">
      <b-row class="mt-5 d-flex justify-content-center">
        <!-- esim -->
        <b-col md="4">
          <div class="bg-white home_banner">
            <a href="https://tstar888.com/geaw/esim" target="_blank">
              <b-row class="py-3 px-4">
                <b-col cols="12">
                  <!-- <b-col cols="12" xl="8" > -->
                  <h4 class="text_green mb-4 mt-3"><b>出國上網新選擇 - eSIM 免換卡更方便！</b></h4>
                  <p>日韓歐美、多國套餐，涵蓋各國的上網方案，點擊查看 eSIM 方案！</p>
                </b-col>
                <!-- <b-col cols="12" xl="4" >
                  <b-img fluid src="@/assets/img/esim_illu.png" class="banner_img"></b-img>
                </b-col> -->
              </b-row>
            </a>
          </div>
        </b-col>
        <!-- 旅費測算 + 護照與各國簽證辦理 -->
        <b-col md="4">
          <div class="bg-white home_banner">
            <a href="/tours/price">
              <b-row class="py-3 px-4">
                <b-col cols="12">
                  <h4 class="text_orange my-3"><b>入境台灣旅費測算</b></h4>
                </b-col>
              </b-row>
            </a>
          </div>
          <div class="bg-white home_banner">
            <a href="/tours/visa">
              <b-row class="py-3 px-4">
                <b-col cols="12">
                  <h4 class="text_orange my-3"><b>護照與各國簽證辦理</b></h4>
                </b-col>
              </b-row>
            </a>
          </div>
        </b-col>
        <!-- 出國打高爾夫旅費測算 -->
        <b-col md="4">
          <div class="bg-white home_banner">
            <a href="/tours/price-outbound">
              <b-row class="py-3 px-4">
                <b-col cols="12">
                  <h4 class="text_orange my-3"><b>出國打高爾夫旅費測算</b></h4>
                </b-col>
                <b-col cols="12" class="mt-3 mt-xl-0">
                  <!-- <b-img fluid src="@/assets/img/priceCalImg.png" class="banner_img"></b-img> -->
                </b-col>
              </b-row>
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="d-block d-md-none">
      <b-row class="mt-5 d-flex justify-content-center">
        <b-col md="4">
          <a href="https://tstar888.com/geaw/esim" target="_blank">
            <div class="bg-white home_banner p-2">
              <div class="text_green"><b-icon-sim font-scale="1.3"></b-icon-sim><b>出國上網新選擇 - eSIM 網卡</b></div>
            </div>
          </a>
        </b-col>
        <b-col md="4">
          <a href="/tours/price" target="_blank">
            <div class="bg-white home_banner p-2">
              <div class="text_orange"><b-icon-calculator rotat="20"
                  font-scale="1.3"></b-icon-calculator><b>入境台灣旅費測算</b>
              </div>
            </div>
          </a>
        </b-col>
        <b-col md="4">
          <a href="/tours/visa" target="_blank">
            <div class="bg-white home_banner p-2">
              <div class="text_orange"><b>護照與各國簽證辦理</b>
              </div>
            </div>
          </a>
        </b-col>
        <b-col md="4">
          <a href="/tours/price-outbound" target="_blank">
            <div class="bg-white home_banner p-2">
              <div class="text_orange"><b-icon-calculator rotat="20"
                  font-scale="1.3"></b-icon-calculator><b>出國打高爾夫旅費測算</b>
              </div>
            </div>
          </a>
        </b-col>
      </b-row>
    </b-container>
    <!-- AD宣傳版面 END -->

    <!-- 等待載入時的畫面 -->
    <b-container class="py-4" v-if="categories.length === 0">
      <div class="block_bg">
        <div class="skeleton">
          <b-skeleton height="40px" width="170px" class="mb-3"></b-skeleton>
          <b-skeleton width="100px" class="mb-3"></b-skeleton>
        </div>
        <b-skeleton-img no-aspect height="281px"></b-skeleton-img>
      </div>
    </b-container>

    <!-- 所有旅遊團 -->
    <section class="card_area2">
      <b-container class="text-center bg-white">
        <h3>{{ $t('index.alltours') }}</h3>
        <div v-for="(category, index) in categories" :key="index" class="">
          <!-- 大分類 -->
          <div class="block_bg" v-if="category.tours.length > 0">
            <div class="text-left">
              <h5 :id="'fromhome' + category.id">{{ category.title }}</h5>
              <div class="px-3 mt-2">
                <!-- 子分類 -->
                <a :href="'/tours/search/' + sub.id" v-for="(sub, index) in category.child" :key="index">
                  <div class="mx-1 mb-1 badge_btn" v-if="sub.tours.length > 0">
                    {{ sub.title }}
                  </div>
                </a>
              </div>
            </div>
            <div class="mt-4">
              <b-row>
                <!-- 旅遊團卡片 -->
                <b-col cols="6" sm="4" class="mb-2" v-for="tour in category.tours" :key="tour.id">
                  <ProductCard :tour="tour" />
                </b-col>
              </b-row>
            </div>
          </div>
          <hr v-if="index !== categories.length - 1 && categories[index + 1].tours.length > 0">
        </div>
      </b-container>
    </section>

    <!-- <b-container class="py-4 card_area2">
      <div v-for="(category, index) in categories" :key="index" class="block_bg">
        <div class="text-center">
          <h4>{{category.title}}</h4>
          <div class=" px-4 mt-2">
            <h5>
              <b-badge
              @click="clickSub(sub.id, sub.title)"
              v-for="(sub, index) in category.subcategory" :key="index"
              class="mx-1">
              {{sub.title}}
              </b-badge>
            </h5>
          </div>
        </div>
        <div class="mt-3">
          <b-row>
            <b-col sm="4" class="mb-2">
              <ProductCard :tour="tours[0]" />
            </b-col>
            <b-col sm="4" class="mb-2">
              <ProductCard :tour="tours[0]" />
            </b-col>
            <b-col sm="4" class="mb-2">
              <ProductCard :tour="tours[0]" />
            </b-col>
            <b-col sm="4" class="mb-2">
              <ProductCard :tour="tours[0]" />
            </b-col>
          </b-row>
          <div class="view_more">
            <router-link :to='"/tour/" + 0' >看更多{{sub.title}}</router-link>
          </div>
        </div>
      </div>
    </b-container> -->

    <!-- <div class="ad_section">
      <div class="ad">購買eSIM</div>
      <div class="ad">入境台灣旅費測算</div>
      <div class="ad">入境台灣旅費測算</div>
    </div> -->

  </div>
</template>

<script>
// @ is an alias to /src
import ProductCard from '@/components/ProductCard.vue'

export default {
  name: 'HomeView',
  components: {
    ProductCard
  },
  data() {
    return {
      // x
      departure: [],
      registration: [],
      orderData: [],
      recommended: [],
      nav: [],
      selectedCategory: null,
      options: [
      ],
      swiperOption: {
        effect: 'fade',
        speed: 1200,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          clickable: true
        },
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        }
      },
      categories: [],
      sub: ''
    }
  },
  mounted() {
    this.scrollToHash()
  },
  computed: {
    // 判斷裡面是否有true來顯示
    hasActiveTours() {
      return this.departure.some(tour => tour.registration_info.status)
    }
  },
  methods: {
    clickSub(id, title) {
      alert(id + title)
      this.$router.push('/search/' + id)
    },
    scrollToHash() {
      setTimeout(() => {
        const hash = window.location.hash
        if (hash) {
          const element = document.querySelector(hash)
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
          }
        }
      }, 1500) // 根據頁面加載時間調整延遲時間
    }
  },
  async created() {
    // 如果是推薦連結，記推薦碼
    if (this.$route.name === 'Referrer') {
      console.log(this.$route.params.token)
      this.$store.commit('setReferrer', this.$route.params.token)
    }

    // 精選
    // try {
    //   const { data } = await this.api.post('php_modules2/category.php?type=r1&recommended=true&language=' + this.$i18n.locale)
    //   console.log(data, '精選行程')
    //   data.data.forEach((c) => {
    //     c.child.forEach(item => {
    //       if (item.tours.length === 0) return
    //       item.tours.forEach(tour => {
    //         this.recommended.push(tour)
    //       })
    //     })
    //   })
    // } catch (error) {
    //   this.$swal({
    //     icon: 'error',
    //     title: '錯誤',
    //     text: '讀取精選資料失敗'
    //   })
    // }

    // 精選
    try {
      const { data } = await this.api.post('php_modules2/category.php?type=r1&recommended=true&language=' + this.$i18n.locale)
      console.log(data, '精選行程')
      this.recommended = data.data.flatMap(item => item.tours)
    } catch (error) {
      this.$swal({
        icon: 'error',
        title: '錯誤',
        text: '讀取精選資料失敗'
      })
    }

    try {
      const { data } = await this.api.post('php_modules2/category.php?type=r1&language=' + this.$i18n.locale)
      console.log(data, '所有一般行程')
      this.categories = data.data

      // 把分類轉成下拉選單options格式
      let i = -1
      this.categories.forEach((c) => {
        if (c.tours.length === 0) return // 大分類有團的話，製作下拉選單選項
        this.options.push({ label: c.title, options: [] })
        i++
        c.child.forEach(item => { // 把有團的子分類加到大分類的options
          if (item.tours.length === 0) return
          // console.log(i)
          this.options[i].options.push({ text: item.title, value: item.id })
        })
      })

      // 熱門分類
      this.departure = []
      this.departure = data.data.flatMap(item => item.tours)

      console.log(this.departure, 'this.departure')

      // 搜尋框加上預設文字
      this.options.unshift({
        value: null,
        text: this.$t('searchBoxTxt')
      })
      // console.log(this.options)
    } catch (error) {
      this.$swal({
        icon: 'error',
        title: '錯誤',
        text: '讀取分類資料失敗' + error
      })
    }
    this.scrollToHash()
  }
}
</script>

<style lang="scss">
#home {
  .ad_section {
    position: fixed;
    left: 0;
    bottom: 10px;
  }

  .ad {
    background-color: #fff;
    // width: 40px;
    // height: 40px;
  }

  .home_banner {
    text-align: center;
    box-shadow: var(--shadow);
    margin-bottom: 1rem;

    &:hover {
      .banner_img {
        transform: scale(96%);
        filter: hue-rotate(-40deg);
      }
    }

    .banner_img {
      transform: scale(101%);
      transition: .5s;
    }
  }

  .nav {
    background-color: #f8f8f8;
    padding: 5px 2.5px;
    // white-space: nowrap;
    // overflow: auto;
    // display: block;
  }

  .nav-item {
    margin: 0 2.5px;
    display: inline-block;

    a {
      font-weight: 500;
      color: #687085;
    }
  }

  background-color: #f5f5f5;

  .searchBg {
    background: url('@/assets/img/pexels-dominika-roseclay-12525002.jpg') center/cover;
    padding: 1em 1em;
  }

  .decoTxt {
    max-width: 460px;
  }

  h3 {
    letter-spacing: 1.5px;
    // font-family: 'Abril Fatface', 'Noto Sans JP';
    transform: translateY(-50%);
    font-weight: 500;
  }

  .recommended h3 {
    text-shadow: 2px 2px 0px #fff;
  }

  .alertbg {
    background-color: #fffdf4;
    border: thick double #ebd5b4;
    border-radius: 10px;
  }

  #swiper_banner {

    // width: 100;
    // height: 100px;
    // background-size: cover;
    & img {
      max-width: 100vw;
    }
  }

  .skeleton {
    display: flex;
    align-items: center;
    flex-direction: column;

    .b-skeleton {
      display: inline-block;
      text-align: center;
    }
  }

  @media (min-width:576px) {
    #section1 {
      #cover {
        display: flex;
        justify-content: center;
      }

      #coverImg {
        margin-left: 100px;
        width: 50vw;
        height: 60vw;
        object-fit: cover;
      }

      #sub {
        display: flex;
        margin-top: -100px;
      }

      #subImg {
        display: block;
        height: 25vw;
        left: 10%;
        position: relative;
        top: 60%;
      }

      #txt {
        top: 20vw;

        h5,
        h6 {
          margin: 0 15px;
          padding: 16px 4px;
        }

        h6 {
          margin: 10px 10px;
          padding: 12px 3px;
        }
      }
    }
  }

  .card_area2 {
    margin-top: 4rem;

    h5 {
      font-weight: 500;
      display: inline-block;
      // background-color: #c5ccdd;
      letter-spacing: 1px;
    }
  }

  .header {
    margin: 1rem 0;
    letter-spacing: 2px;
    text-align: center;
    font-weight: 500;
  }

  .categories,
  .circle {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .categories {
    margin-top: 1rem;
    padding: 1rem 0 1rem;
    background-color: var(--myblue2);
  }

  .category_img {
    border-radius: 50%;
    margin-bottom: .5rem;
  }

  .category {
    display: flex;
    flex-wrap: nowrap;
  }

  .bar {
    display: flex;
    flex-wrap: nowrap;
    max-width: 650px;
  }

  .circle {
    margin: .25rem;
  }

  .banner {
    background: linear-gradient(rgba(0, 0, 0, 0) 85%, rgba(255, 255, 255, 1)),
      url(@/assets/img/banner.jpg) no-repeat 50% 0%/cover;
    height: 45vw;
    padding: 16rem 0 1rem;
    color: #fff;
    margin-bottom: 1.5rem;

    .bannerTxt {
      position: absolute;
      top: 200px;
      left: 60px;
      color: #3c404b;

      h4 {
        background-color: #fff;
        margin-bottom: 1rem;
      }

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      letter-spacing: 2px;
      // text-shadow: 0 0 10px rgb(0, 0, 0);
    }
  }

  // 卡片padiing間距調整
  .row {
    padding: 0 10px;
  }

  .col-6 {
    padding: 6px;
  }

  .ProductCard {
    .card {
      background: none;
    }
  }

  .tour {
    // background-color: var(--myblue2);
    padding: 1rem 0;
  }

  .view_all {
    // display: inline-block;
    text-align: right;
    font-weight: 500;
    font-size: .9rem;

    a {
      color: var(--myblue);

      &:hover {
        color: #3c404b;
      }
    }
  }

  @media (min-width:768px) {
    .circle {
      margin: .8rem;
    }

    .col-6 {
      padding: 10px;
    }

    .col-sm-6 {
      padding: 0 35px;
    }
  }

  @media (min-width: 1200px) {
    .home_banner {
      text-align: left;
    }
  }
}
</style>
